import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getHeaderNotification, getFaqsData, getPressMedia} from '../utils/endpoints'
import { Container, Row, Col } from 'react-bootstrap';
import Loading from './components/loading';
import HeaderNotification from './components/headerNotification';
import Faqs from './components/faq';
import Header from './components/header';
import Footer from './components/footer';
import { Helmet } from 'react-helmet';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

const HowToReach = (props) => {
    const [headerNotificationData, setheaderNotificationData] = useState(null);
    const [faqs, setFaqs] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const pressMediaData = await getPressMedia(id);
            const headerNotificationData = await getHeaderNotification();
            setheaderNotificationData(headerNotificationData);
            const faqs = await getFaqsData();
            setFaqs(faqs);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);

      const faQSlice = faqs;
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
        return <div>Error: {error.message}</div>;
      }

  return (
    <div>
      <Helmet>
      <title>How to Reach Statue of Belief | Statue of Belief</title>
      </Helmet>
        <HeaderNotification compData={headerNotificationData}/>
        <Header />
        <section className='section-breadcrumb'>
          <Container>
          <ul>
                <li><a href="/">Home</a></li>
                <li>How to Reach Statue of Belief</li>
            </ul>
            <h1>How to Reach Statue of Belief</h1>
          </Container>
        </section>
        <Container className='pt-5 section-howToReach'>
        <Row>
          <Col lg={8} className='mb-lg-0 mb-4'>
          <Tabs
              defaultActiveKey="tab-01"
              className=""
            >
              <Tab eventKey="tab-01" title="By Air">
              <div className='howToReach-Wrapper'>
                <p>Maharana Pratap Airport in Udaipur is your best choice for air travel. It's the airport closest to the Statue of Belief.</p>
                <p className='mb-4'>Based on your journey, please consider the following options for air travel. Below is a list of the nearest airports. Choose the one that best fits your needs.</p>
                <Row>
                  <Col lg={4} className='mb-lg-0 mb-4'>
                    <h2>Maharana Pratap Airport</h2>
                    <ul>
                      <li><b>Distance</b> : 48 Km</li>
                      <li><b>Time to Reach</b> : 1 hrs</li>
                    </ul>
                  </Col>
                  <Col lg={4} className='mb-lg-0 mb-4'>
                    <h2>Jodhpur Airport</h2>
                    <ul>
                      <li><b>Distance</b> : 210 Km</li>
                      <li><b>Time to Reach</b> : 4 hrs</li>
                    </ul>
                  </Col>
                  <Col lg={4}>
                    <h2>Jaipur International Airport</h2>
                    <ul>
                      <li><b>Distance</b> : 360 Km</li>
                      <li><b>Time to Reach</b> : 6 hrs</li>
                    </ul>
                  </Col>
                </Row>
              </div>
              </Tab>
              <Tab eventKey="tab-02" title="By Train">
              <div className='howToReach-Wrapper'>
              <p>If you're planning to travel by train, Udaipur Railway Station (UDZ) in Udaipur should be your preferred choice.</p>
              <p>Assess your journey requirements, and consider the options provided. Below is a list of railway stations. Select the one that aligns best with your travel plans and needs.</p>
                <Row>
                  <Col lg={4} className='mb-lg-0 mb-4'>
                    <h2>MAVLI JN</h2>
                    <ul>
                      <li><b>Distance</b> : 28 Km</li>
                      <li><b>Time to Reach</b> : 50 Minutes</li>
                    </ul>
                  </Col>
                  <Col lg={4} className='mb-lg-0 mb-4'>
                    <h2>UDAIPUR CITY</h2>
                    <ul>
                      <li><b>Distance</b> : 46 Km</li>
                      <li><b>Time to Reach</b> : 1 hr</li>
                    </ul>
                  </Col>
                  <Col lg={4}>
                    <h2>KAPASAN</h2>
                    <ul>
                      <li><b>Distance</b> : 70 Km</li>
                      <li><b>Time to Reach</b> : 1 hr 20 Minutes</li>
                    </ul>
                  </Col>
                </Row>
              </div>
              </Tab>
              <Tab eventKey="tab-03" title="By Road">
              <div className='howToReach-Wrapper'>
              <p>The Statue of Belief is strategically located about 45 kilometers away from Udaipur. This imposing structure is easily visible even from a distance of 20 kilometers, enhancing its prominence in the region.</p>
              <p>Access to the statue is made convenient by its connectivity through National Highway 8, making it easily reachable for visitors.</p>
              <div className='mapWrapper mb-5'>
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28946.756101221952!2d73.817235!3d24.920331!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39680d17f5546a41%3A0xa10522268d83a57e!2sVishwas%20Swaroopam%20(Statue%20of%20Belief)!5e0!3m2!1sen!2sin!4v1685170056383!5m2!1sen!2sin"  height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
              </div>
              </Tab>
            </Tabs>
          </Col>
          {/* <Col lg={4}>
            <div className='cab_wrapper'>
              <h2>Book a Cab</h2>
              <ul>
                <li>Guaranteed Lowest Rates and well maintained vehicles.</li>
                <li>100% instant Confirmation</li>
                <li>Lorem ipsum dolor sit amet</li>
                <li>Lorem ipsum dolor sit amet</li>
                <li>Lorem ipsum dolor sit amet</li>
              </ul>
              <div><a href="#">Book now</a></div>
            </div>
          </Col> */}
        </Row>
      </Container>
      <Faqs compData={faQSlice.slice(0,5)} />
      <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
      <Footer />
    </div>
  );
};

export default HowToReach;